import { useMemo } from "react";

import { getSearchGroups, getSearchOrderedItems } from "@utils/related-items.util";
import { RelatedItem } from "@app-types/related-items.type";

export function useMentions(items: RelatedItem[]) {
  const groups = useMemo(() => getSearchGroups(items), [items]);
  const orderedItems = useMemo(() => getSearchOrderedItems(groups), [groups]);

  return { groups, orderedItems };
}
